<template>
  <div class="text-banner">
    <v-card
      v-for="(banner, i) in banners"
      :key="i"
      :color="banner.backgroundColor"
      :role="banner.role"
      :class="
        i == visible
          ? 'text-banner-content__active'
          : 'text-banner-content__inactive'
      "
      :data-banner-index="i"
      class="text-banner-content mb-3 mb-1 px-2 py-3 transparent-border"
    >
      <div class="d-flex flex-grow justify-center">
        <div class="pr-3" style="justify-content: center;text-align: right;">
          <v-icon :color="banner.iconColor">{{ banner.icon }}</v-icon>
        </div>
        <div
          class="text-banner-content-paragraph"
          style="align-self:center;max-width: 45em;"
        >
          <div v-html="banner.contentText" />
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
export default {
  name: "AppTextBannerCollection",
  props: {
    banners: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: 0,
      nextTimeout: null
    };
  },
  mounted() {
    if (this.banners.length > 1) {
      this.setIntervalCarousel(this.banners[0].rotateAfterSeconds);
    }
  },
  beforeDestroy() {
    clearTimeout(this.nextSlideTimeout);
  },
  methods: {
    setIntervalCarousel(bannerRotateSeconds) {
      if (!bannerRotateSeconds) return;
      if (this.banners.length <= 1) return;
      this.nextTimeout = setTimeout(() => {
        this.next();
      }, bannerRotateSeconds * 1000);
      // Wants in milliseconds
    },
    next() {
      this.visible =
        this.banners.length > this.visible + 1 ? this.visible + 1 : 0;
      if (this.banners[this.visible]) {
        this.setIntervalCarousel(this.banners[this.visible].rotateAfterSeconds);
      }
    }
  }
};
</script>
<style scoped lang="scss">
.text-banner {
  &-content {
    &__active {
      display: block;
    }
    &__inactive {
      display: none;
    }
  }
}
</style>
